// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"699ed066","455":"3519ceca","977":"33a8c4b5"}[chunkId] + ".chunk.js";
};